import styled from "styled-components";

export const CandidateExpWrapper = styled.div`
  /* border: 2px solid red; */
  background-color: #f5f5f5;
  flex: 1;
  overflow: auto;
`;
